import Vue from "vue";
import VueRouter, { Location, RouteConfig } from "vue-router";
import store from "../store";
import HomePage from "../pages/home/HomePage.vue";
import BoothsPage from "../pages/booths/BoothsPage.vue";
import LoginPage from "../pages/auth/LoginPage.vue";
import RegistrationPage from "../pages/auth/RegistrationPage.vue";
import ResetPasswordPage from "../pages/ResetPassword/ResetPasswordPage.vue";
import UserProfilePage from "../pages/UserProfile/UserProfilePage.vue";
import TrainingRoomPage from "../pages/TrainingRoom/TrainingRoomPage.vue";
import QuizPage from "../pages/QuizPage/QuizPage.vue";
import InfoDeskPage from "../pages/InfoDesk/InfoDeskPage.vue";
import NotFound from "../pages/NotFound/NotFound.vue";
import Workshop from "@/pages/Workshops/Workshop.vue";
import BattleRoom from "@/pages/BattleRooms/BattleRoom.vue";
import EditUserAvatar from "@/pages/EditUserAvatar/EditUserAvatar.vue";
import Leaderboard from "@/pages/LeaderBoard/Leaderboard.vue";
import MobileNotifications from "@/pages/MobileNotifications/MobileNotifications.vue";
import ChangePasswordPage from "@/pages/ChangePassword/ChangePasswordPage.vue";
import UserManual from "@/pages/UserManual/UserManual.vue";
import { i18n } from "@/i18n";

Vue.use(VueRouter);

export const updatePageTitle = (route: any) => {
    window.document.title = `${i18n.t(route.name)}`;
}

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        component: HomePage,
        meta: {
            requiresAuth: true,
            showNews: true
        }
    },
    {
        path: "/booths_games",
        name: "Interactive Games",
        component: BoothsPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/',
            showNews: true
        }
    },
    {
        path: "/booths_lessons",
        name: "Awareness Videos",
        component: BoothsPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/',
            showNews: true
        }
    },
    {
        path: "/workshops",
        name: "Workshops",
        component: Workshop,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/'
        }
    },
    {
        path: "/battles",
        name: "Battle Room",
        component: BattleRoom,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/'
        }
    },
    {
        path: "/login",
        name: "Login",
        component: LoginPage
    },
    {
        path: "/register",
        name: "Registration",
        component: RegistrationPage
    },
    {
        path: "/reset_password",
        name: "Reset Password",
        component: ResetPasswordPage,
        meta: {
            requiresAuth: false,
            showTitleInMobile: false,
            showTitleInDesktop: false,
            returnUrl: '/login'
        }
    },
    {
        path: "/userprofile",
        name: "User Profile",
        component: UserProfilePage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: false,
            returnUrl: '/'
        }
    },
    {
        path: "/useravatar",
        name: "Edit Profile Picture",
        component: EditUserAvatar,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: false,
            returnUrl: '/userprofile'
        }
    },
    {
        path: "/leaderboard",
        name: "Leader Board",
        component: Leaderboard,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/'
        }
    },
    {
        path: "/game_room",
        name: "Game Room",
        component: () => import(`../pages/GameRoom/GameRoomPage.vue`),
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/booths_games'
        }
    },
    {
        path: "/training_room",
        name: "Training Room",
        component: TrainingRoomPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/booths_lessons'
        },
    },
    {
        path: "/interactive_lesson",
        name: "Interactive Lesson Room",
        component: TrainingRoomPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/booths_lessons'
        },
    },
    {
        path: "/quiz",
        name: "Lesson Quiz",
        component: QuizPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/booths_lessons'
        },
    },
    {
        path: "/mobile_notifications",
        name: "Notifications",
        component: MobileNotifications,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/'
        },
    },
    {
        path: "/info_desk",
        name: "Info Desk",
        component: InfoDeskPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: false,
            returnUrl: '/'
        }
    },
    {
        path: "/change_password",
        name: "Change Password",
        component: ChangePasswordPage,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: false,
            returnUrl: '/'
        }
    },
    {
        path: "/user_manual",
        name: "Video Tutorial",
        component: UserManual,
        meta: {
            requiresAuth: true,
            showTitleInMobile: true,
            showTitleInDesktop: true,
            returnUrl: '/'
        }
    },
    {
        //This Should always be the last route
        path: "*",
        name: "NotFound",
        component: NotFound
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.requiresAuth) {
        //No need to redirect from here as the interceptor redirects to the login on 401
        //currently that interceptor is in the main.ts
        store.dispatch("tryAutoLogin", to.path).then(() => {
            next();
            updatePageTitle(to);
        });
    } else {
        next();
        updatePageTitle(to);
    }
});
export default router;
